import * as React from 'react'
import { Widget, mk_widget } from 'widgets-for-react'
import { styleguideChapter } from '../helpers.mod'

export const styleguideAbout: Widget<never> = mk_widget({
  run: (_) =>
    styleguideChapter({ type: 'about', slug: 'about', title: 'About', intro: '' })(
      mk_widget({
        run: (_) => (
          <>
            <p className="styleguide-chapter__intro styleguide--styled">
              This styleguide contains all components used on the Refresco Corporate website.
            </p>
          </>
        )
      })
    ).run(_)
})
